export default "__VITE_ASSET__CLXUfoDC__"